import PropTypes from 'prop-types'
import styles from './Precios.module.css'

const IVA_ENVIO = 1.21

const formatoAR = (valor) =>
  (Number(valor) || 0).toLocaleString('es-AR', { maximumFractionDigits: 2 })

const Precios = ({
  nombre,
  precio,
  monedaSimbolo,
  alicuota = 0,
  cantidad = 1,
  mostrarCantidad = false,
  sufijo = '',
  className = '',
  showSinIVA = false,
  items = null,
  costoEnvio = 0
}) => {
  const alicuotaNumerica = Number(alicuota) || 0
  const cantidadNumerica = Number(cantidad) || 1

  let totalSinIva = 0
  let totalConIva = 0

  if (Array.isArray(items) && items.length > 0) {
    const obtenerUnitarioEfectivo = (item) => {
      const cantidadItem = Number(item.cantidad) || 1
      // Normalizar listas mayoristas
      let lista = []
      if (Array.isArray(item.preciosMayoristas) && item.preciosMayoristas.length > 0) {
        lista = item.preciosMayoristas
      } else if (
        Array.isArray(item.preciosMayorista) &&
        item.preciosMayorista.length > 0
      ) {
        lista = item.preciosMayorista
      } else if (item.precioUnitarioMayorista && item.cantidadMayorista) {
        lista = [
          {
            cantidad: Number(item.cantidadMayorista) || 0,
            precioUnitario: Number(item.precioUnitarioMayorista) || 0
          }
        ]
      }
      if (Array.isArray(lista) && lista.length > 0) {
        const tramo = [...lista]
          .sort((a, b) => Number(b.cantidad) - Number(a.cantidad))
          .find((p) => cantidadItem >= Number(p.cantidad))
        if (tramo && Number(tramo.precioUnitario) > 0) {
          return Number(tramo.precioUnitario)
        }
      }
      return Number(item.precioUnitario) || 0
    }

    totalSinIva =
      items.reduce((acc, item) => {
        const precio = obtenerUnitarioEfectivo(item)
        const cantidad = Number(item.cantidad) || 0
        return acc + precio * cantidad
      }, 0) + Number(costoEnvio)
    const costoEnvioConIva = Number(costoEnvio) * IVA_ENVIO
    totalConIva =
      items.reduce((acc, item) => {
        const precio = obtenerUnitarioEfectivo(item)
        const cantidad = Number(item.cantidad) || 0
        const alicuotaIVA = Number(item.alicuota) || 0
        return acc + precio * cantidad * (1 + alicuotaIVA / 100)
      }, 0) + (costoEnvio > 0 ? costoEnvioConIva : 0)
  } else {
    const precioUnitario = Number(precio) || 0
    const precioUnitarioSinIva = precioUnitario
    const precioUnitarioConIva = precioUnitario * (1 + alicuotaNumerica / 100)

    const esUnitario = cantidadNumerica <= 1
    totalSinIva = esUnitario
      ? precioUnitarioSinIva
      : precioUnitarioSinIva * cantidadNumerica
    totalConIva = esUnitario
      ? precioUnitarioConIva
      : precioUnitarioSinIva * cantidadNumerica * (1 + alicuotaNumerica / 100)
  }

  return (
    <div className={`${styles.precios} ${className}`}>
      <div className={styles['precios__principal']}>
        {nombre && <span className={styles['precios__nombre']}>{nombre}: </span>}
        <span className={`${styles['precios__valor']}`}>
          {monedaSimbolo}
          {formatoAR(totalConIva)}
        </span>
        {mostrarCantidad && (
          <span className={styles['precios__cantidad']}>(x{cantidadNumerica})</span>
        )}
        {sufijo && <span className={styles['precios__sufijo']}>{sufijo}</span>}
      </div>
      {showSinIVA && (
        <div className={`${styles['precios__sin-iva']}`}>
          Sin IVA: {monedaSimbolo}
          {formatoAR(totalSinIva)}
        </div>
      )}
    </div>
  )
}

Precios.propTypes = {
  nombre: PropTypes.string,
  precio: PropTypes.number,
  monedaSimbolo: PropTypes.string.isRequired,
  alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cantidad: PropTypes.number,
  mostrarCantidad: PropTypes.bool,
  sufijo: PropTypes.string,
  showSinIVA: PropTypes.bool,
  className: PropTypes.string,
  items: PropTypes.array,
  costoEnvio: PropTypes.number
}

export default Precios
